//TODO: level example, remove me when useless

import Level from '../core/level.js'

const level = new Level({
    name: 'example_emoticons'
})


level.addQuestion({
    generator: function (q) {
        q.addText('3->5 78 -> 98')
        q.answer = 1
    },
    times: 3
})


export default level

